import { defineMessages, IntlShape, MessageDescriptor } from 'react-intl';
import { mediaKindOfDraft, PromoteMediaDraft } from '../draftStore';
import { PostMediaKind } from '../platformMeta';
import { clockLabel } from './tiktok/clockLabel';

export const composerMediaKindMessages: Record<PostMediaKind, MessageDescriptor> = defineMessages({
  image: { id: 'app.sml.promote.composer.media.kind.image', defaultMessage: 'Image' },
  video: { id: 'app.sml.promote.composer.media.kind.video', defaultMessage: 'Video' },
});

/**
 * The fact line of a file: "9:16 · Video · 0:30", "4:5 · Image". A part that is not known is
 * left out. The Composer media row and the picker tiles use it.
 */
export function mediaFactsLine(
  intl: IntlShape,
  facts: { kind: PostMediaKind; aspect: string; durationSec: number | null }
): string {
  const parts = [
    facts.aspect,
    intl.formatMessage(composerMediaKindMessages[facts.kind]),
    facts.kind === 'video' && facts.durationSec !== null ? clockLabel(facts.durationSec) : '',
  ];
  return parts.filter((part) => part !== '').join(' · ');
}

/** The fact line of the attached media. */
export function composerMediaMeta(intl: IntlShape, media: PromoteMediaDraft): string {
  return mediaFactsLine(intl, { kind: mediaKindOfDraft(media), aspect: media.aspect, durationSec: media.durationSec });
}

/** "Forests · Story (Out now)"; the song title alone when the media has no name. */
export function composerMediaTitle(intl: IntlShape, media: PromoteMediaDraft): string {
  if (media.label === undefined || media.label === '') {
    return media.title;
  }
  if (media.title === '') {
    return media.label;
  }
  return intl.formatMessage(
    { id: 'app.sml.promote.composer.media.named', defaultMessage: '{title} · {label}' },
    { title: media.title, label: media.label }
  );
}
